import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Card, Spin, Empty } from 'antd';
import SalesScreenLeftHeader from '../../molecules/SalesScreeenLeftHeader/SalesScreenLeftHeader';
import SalesScreenRightHeader from '../../molecules/SalesScreenRightHeader/SalesScreenRightHeader';
import SalesFilterSection from '../../molecules/SalesFilterSection/SalesFilterSection';
import SalesLeftTableSection from '../../molecules/SalesLeftTableSection/SalesLeftTableSection';
import ProductCard from '../../atoms/ProductCard/ProductCard';
import { getWarehouseStockListApi } from '../../redux/slice/warehouseStock/getWarehouseStockListSlice';
import { getWarehouseListApi, getWarehouseListReset } from '../../redux/slice/warehouse/getWarehouseListSlice';

const SalesScreenOrganism = () => {
  const dispatch = useDispatch();
  const [warehouseDataList, setWarehouseDataList] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [searchBrandCataGory, setSearchBrandCataGory] = useState('');
  const [warehouseList, setWarehouseList] = useState([]);
  const [warehouseId, setWarehouseId] = useState(0);

  const getWarehouseStockListState = useSelector((state) => state.getWarehouseStockListState);
  const getWarehouseListState = useSelector((state) => state.getWarehouseListState);

  useEffect(() => {
    dispatch(getWarehouseStockListApi(searchBrandCataGory));
    dispatch(getWarehouseListApi());
    return () => {
      dispatch(getWarehouseListReset());
    };
  }, [dispatch, searchBrandCataGory]);

  useEffect(() => {
    if (getWarehouseStockListState.status === 'success') {
      setWarehouseDataList(getWarehouseStockListState.data);
    }
    if (getWarehouseStockListState.status === 'error') {
      setWarehouseDataList([]);
    }
  }, [getWarehouseStockListState.status]);

  useEffect(() => {
    if (getWarehouseListState.status === 'success') {
      let data = [];
      getWarehouseListState.data.map((item) => {
        data.push({
          value: item.warehouseId,
          label: item.name,
        });
      });
      setWarehouseList(data);
    }
  }, [getWarehouseListState]);

  const handleProductSelect = (productID) => {
    const selectedProduct = warehouseDataList.find((product) => product.warehouseStockID === productID);
    if (selectedProduct && !selectedProducts.some((product) => product.warehouseStockID === productID)) {
      setSelectedProducts((prev) => [...prev, selectedProduct]);
    }
  };

  const handleProductDeselect = (productID) => {
    setSelectedProducts((prev) => prev.filter((product) => product.warehouseStockID !== productID));
  };

  const handleWarehouse = (value) => {
    setWarehouseId(value);
  };

  return (
    <Row gutter={[16, 16]} style={{ padding: '10px' }}>
      {/* Left Section */}
      <Col xs={24} md={8} lg={10}>
        <SalesScreenLeftHeader warehouseList={warehouseList} handleWarehouse={handleWarehouse} />
        <Card style={{ height: '100%' }}>
          <SalesLeftTableSection
            selectedProducts={selectedProducts}
            onProductDeselect={handleProductDeselect}
            warehouseId={warehouseId}
          />
        </Card>
      </Col>
      {/* Right Section */}
      <Col xs={24} md={14} lg={14}>
        <SalesScreenRightHeader getInputFromDropdown={handleProductSelect} />
        <Card style={{ height: '100%' }}>
          <div style={{ marginBottom: '10px' }}>
            <SalesFilterSection
              getFilterValue={(value) => {
                setSearchBrandCataGory(value);
              }}
              searchBrandCataGory={searchBrandCataGory}
            />
          </div>
          <div style={{ height: 'calc(100vh - 200px)', overflowY: 'auto' }}>
            {getWarehouseStockListState.status === 'loading' ? (
              <div style={{ textAlign: 'center', padding: '20px' }}>
                <Spin size='large' />
              </div>
            ) : (
              <Row gutter={[16, 16]}>
                {warehouseDataList && warehouseDataList.length > 0 ? (
                  warehouseDataList.map((product, index) => (
                    <Col
                      onClick={() => handleProductSelect(product.warehouseStockID)}
                      key={index}
                      xs={24}
                      sm={12}
                      md={6}
                      lg={6}
                    >
                      <ProductCard loading={getWarehouseStockListState.status === 'loading'} product={product} />
                    </Col>
                  ))
                ) : (
                  <div style={{ textAlign: 'center', padding: '20px' }}>
                    <Empty description='No Data Found' />
                  </div>
                )}
              </Row>
            )}
          </div>
        </Card>
      </Col>
    </Row>
  );
};

export default SalesScreenOrganism;
